module.exports = __webpack_public_path__ + "img/bike-selected.a4859e20.svg";